// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"59d6e4ff","238":"59d6e4ff","256":"59d6e4ff","293":"59d6e4ff"}[chunkId] + ".css";
};